import { useEffect, useState } from 'react';

/**
 * The value as it was `delayMs` ago, once it has stopped changing.
 *
 * For a search box whose every keystroke would otherwise become a request:
 * the query hook reads the settled value, and the typist's burst collapses
 * into one call.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(
    function settleAfterDelay() {
      const timer = window.setTimeout(() => setSettled(value), delayMs);
      return () => window.clearTimeout(timer);
    },
    [value, delayMs]
  );

  return settled;
}
